import getCustomHiddenFields from "../customHiddenFields";
import getHiddenFields from "../hiddenFields";
import disableStylesheets from "./disableStylesheets";
import formHandlers, { handleDefaultStateAndLabelFormRows } from "./formHandlers";
import handleDemoLicenseRegistration, { removeDlrCookie } from "./demoLicenseRegistration";
import handleMultistepForm from "./mutlistep";
import { isEmailValid } from "./validation";
import setGeoCountry from "./geoCountry";
import { assertHiddenFieldsOnForm, assertMktoGlobal } from "../errors";

export default function() {
    let initialized = false;

    removeDlrCookie();

    if (typeof MktoForms2 === "undefined") {
        return;
    }

    assertMktoGlobal("mktoMessages", () => mktoMessages);

    MktoForms2.whenRendered(function(form) {
        const formElement = form.getFormElem()[0];

        handleDefaultStateAndLabelFormRows(formElement);

        if (!initialized) {
            disableStylesheets(formElement);
            formHandlers(formElement);
            handleDemoLicenseRegistration(formElement);
            handleMultistepForm(form, formElement);

            setGeoCountry(form);

            form.onValidate(() => {
                isEmailValid(form);
            });

            form.onSubmit(() => {
                const customHiddenFields = getCustomHiddenFields();
                const hiddenFields = getHiddenFields();

                assertHiddenFieldsOnForm(form, customHiddenFields, "mktoHiddenFields (footer)");
                assertHiddenFieldsOnForm(form, hiddenFields, "UTM cookies (hiddenFields.js)");

                form.vals(customHiddenFields);
                form.vals(hiddenFields);
            });

            initialized = true;
        }
    });
}
